import React from 'react';
import { Header, ContentHeader } from './../Calculators/Header';
import { SmallIntro } from './../Calculators/Intro';
import { ButtonPanel } from './../Calculators/ButtonPanel';
import { OneColumnLayout } from './../Calculators/Sections';
import { Button, ButtonLink, RangerInput } from './../Form/index';
import { ClientDetails } from './Panel';
import { NoData, TheHouse } from './TheHouse'
// import { Summary } from './Summary';

const titleGI = [
  "With the more 2 life **Inheritance Protection**, if your client doesn’t take the full loan amount offered they can get the best of both" +
  "worlds: money to enjoy their retirement and peace of mind that a percentage of their future property value is protected as an inheritance.",

  "Simply add a few details below to see how it could work for your client."
];

export const GuaranteedInheritanceComponent = ({ screen, guaranteedInheritance, onChangeInput }) => {
  const { input, output } = guaranteedInheritance;
  const maxPrice = 2.25 * input.housePrice;
  const contentHeight = 440;
  return (
    <div>
      <Header  {...screen} title={['Inheritance Protection tool']}/>
      {screen.inFrame ? false : <SmallIntro title={titleGI} padding={20} />}

      <OneColumnLayout>
        <div className="sidebar">
          <ClientDetails {...guaranteedInheritance} onChangeInput={onChangeInput} />
        </div>
        <div className="content" style={{ height: contentHeight, background: '#e8f4ec' }}>
          <ContentHeader color='#209546'>
            <div className="label" style={{ flex: 1 }}>Now</div>
          </ContentHeader>

          {output.amountProtectedAtStart > 0 ? (
            <TheHouse
              contentHeight={contentHeight}
              color='#209546'
              styling='diamond'
              max={maxPrice}
              price={input.housePrice}
              protectedAmount={output.amountProtectedAtStart}
            />
          ) : <NoData />}

        </div>
        <div style={{ width: 20 }}>&nbsp;</div>
        <div className="content" style={{ height: 440, background: '#e5e8e8' }}>
          <ContentHeader color="#0d2926">
             <div className="label">Year</div>
             <RangerInput
                style={{ width: '90%', flex: 1 }}
                value={input.years} min={1} max={15}
                color='#209546' inactiveColor='#f1f9ff' withLabel={true} suffix={''}
               onChange={val => { onChangeInput('years', val) }}
             />
             <div className="gap"></div>
          </ContentHeader>

          {output.amountProtected > 0 ? (
            <TheHouse
              contentHeight={contentHeight}
              color="#000"
              styling='black'
              max={maxPrice}
              price={output.futureHousePrice}
              protectedAmount={output.amountProtected}
            />
          ) : <NoData />}

        </div>

      </OneColumnLayout>

      {screen.inFrame ? false : (
        <ButtonPanel className="footer">
          <ButtonLink to='/' style={{ background: 'black' }}>Back</ButtonLink>
          <div style={{ flex: 1 }}></div>
          <Button disabled={true}>Download PDF Report</Button>
        </ButtonPanel>
      )}
    </div>
  );
};

/*
  <div className="content">
    <Summary {...guaranteedInheritance} />
    <HousePriceChange {...guaranteedInheritance} onChangeInput={onChangeInput} />
  </div>
*/



// WEBPACK FOOTER //
// ./src/components/GuaranteedInheritance/GuaranteedInheritanceComponent.js